import FormField from "components/FormField";
import MDModal from "components/MDModal";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { useState } from "react";
import Select from 'react-select'
import { useDeleteUser } from "queries/users";
import SoftInput from "components/SoftInput";
import { colors, Icon } from "@mui/material";
import { useUserInfo } from "context/user";

function ModalComponent({ open, onClose, accounts, data, handleRefresh }) {
    const userEmail = useUserInfo()[3];
    const [activeLocation, setActiveLocation] = useState(data?.activeLocation || [])
    const [confirmText, setConfirmText] = useState("")

    const { mutateAsync: deleteUser } = useDeleteUser();

    const onConfirm = async () => {
        if (data._id && confirmText.toLowerCase() === "delete") {
            const { response } = await deleteUser(`_id=${data._id}&email=${userEmail}`);
            if (response) {
                onClose();
            }
        }
    };

    return (
        <>
            {open &&

                <div className="modal-zz-confirm text-left">
                    <div
                        className="scrollable-modal-content bg-white rounded"
                        style={{ position: "relative" }}
                    >
                        <h2 className="text-black text-center font-14">Delete User</h2>
                        <p style={{ margin: "10px", textAlign: "center", fontSize: "16px", whiteSpace: 'normal' }}>
                            Are you sure you want to delete the user &quot;{data.userName}&quot;? This action cannot be undone.
                        </p>
                        <div style={{ margin: "20px 10px" }}>
                            <p style={{ fontSize: "14px", marginBottom: "8px", fontWeight: "500" }}>
                                Type <strong>delete</strong> to confirm deletion
                            </p>
                            <SoftInput
                                type="text"
                                placeholder="Type 'delete' to confirm"
                                value={confirmText}
                                onChange={(e) => setConfirmText(e.target.value)}
                                style={{ width: "100%" }}
                            />
                        </div>
                        <div style={{ textAlign: "center" }} mt={3}>

                            <SoftButton
                                variant="contained"
                                color="error"
                                onClick={onConfirm}
                                disabled={confirmText.toLowerCase() !== "delete"}
                                sx={{ marginBottom: 2 }}
                                style={{ 
                                    border: "1px solid red", 
                                    color: confirmText.toLowerCase() === "delete" ? "black" : "#999", 
                                    width: "100%", 
                                    backgroundColor: confirmText.toLowerCase() === "delete" ? "rgba(220, 53, 69, 0.5)" : "rgba(220, 53, 69, 0.2)", 
                                    display: 'block',
                                    cursor: confirmText.toLowerCase() === "delete" ? "pointer" : "not-allowed"
                                }}

                            >
                                Yes, delete account
                            </SoftButton>
                            <SoftButton
                                variant="outlined"
                                color="secondary"
                                onClick={onClose}
                                style={{ width: "100%", color: 'black', border: "1px solid black" }}
                            >
                                No, go back
                            </SoftButton>
                        </div>
                    </div>
                </div>}


        </>

    );
}
ModalComponent.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    accounts: PropTypes.array,
    data: PropTypes.array,
    handleRefresh: PropTypes.func,
};
function Modal({ data, accounts, handleRefresh }) {
    const [openAddMember, setOpenAddMember] = useState(false);

    return (
        <>
            <span
                className="cursor-pointer"
                onClick={() => setOpenAddMember(true)}>
                <Icon>delete</Icon>
            </span>

            <ModalComponent
                open={openAddMember}
                onClose={() => setOpenAddMember(false)}
                accounts={accounts}
                data={data}
                handleRefresh={handleRefresh}
            />
        </>
    );
}
Modal.propTypes = {
    accounts: PropTypes.array,
    data: PropTypes.array,
    handleRefresh: PropTypes.func,
};
export default Modal;
